(() => {
  const root = document.getElementById('MainContent');
  const direct = document.getElementById('usa-royal-mail-link');
  const hint = document.getElementById('usa-royal-mail-hint');
  const area = document.getElementById('usa-courier-link-area');
  if (!root || !direct || !hint || !area) return;
  const base = 'https://www.royalmail.com/track-your-item';
  const number = value => {
    const clean = String(value || '').replace(/\s/g, '').toUpperCase();
    return /^[A-Z0-9]{10,35}$/.test(clean) ? clean : '';
  };
  const url = code => base + '#/tracking-results/' + encodeURIComponent(code);
  const setHref = (link, value) => {
    if (link.getAttribute('href') !== value) link.setAttribute('href', value);
  };
  let queued = false;
  function update() {
    queued = false;
    // Keep this below the shipment status and date, not above the lookup form.
    const status = root.querySelector('.yq-track-shipment-title')?.parentElement;
    if (status && area.parentElement !== status) status.appendChild(area);
    area.hidden = !status;
    const parcels = new Set();
    // Pair each Royal Mail carrier with its own adjacent number, never another parcel.
    root.querySelectorAll('a[class*="ClassicTrackInfo_carrierName"]').forEach(link => {
      let host;
      try { host = new URL(link.href).hostname; } catch (_) { return; }
      if (!/(^|\.)royalmail\.com$/i.test(host)) return;
      const code = number(link.parentElement?.parentElement?.querySelector('[class*="TrackingNumber_trackingNumber__"]')?.textContent);
      if (!code) return;
      parcels.add(code);
      setHref(link, url(code));
      link.title = 'Track this parcel directly with Royal Mail';
      link.rel = 'noopener';
    });
    let selected = parcels.size === 1 ? [...parcels][0] : '';
    if (!parcels.size) {
      const input = root.querySelector('#trackingForm_track_no');
      const candidate = number(input ? input.value : new URLSearchParams(location.search).get('nums'));
      // Without a confirmed carrier, only offer the common single UK parcel format.
      if (/^[A-Z]{2}\d{9}GB$/.test(candidate)) selected = candidate;
    }
    setHref(direct, selected ? url(selected) : base);
    const text = selected ? 'Your tracking number is ready to view.'
      : parcels.size > 1 ? 'For multiple parcels, use each parcel’s Royal Mail link.'
      : 'See the latest updates on Royal Mail.';
    if (hint.textContent !== text) hint.textContent = text;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  root.addEventListener('input', schedule);
  root.addEventListener('change', schedule);
  root.addEventListener('click', schedule);
  window.addEventListener('popstate', schedule);
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
  update();
})();
